import {
  ConnectionListResult,
  FeatureFlagsContext,
  GridSortProps,
  MaxCountsResultData,
  PaginatedQueryWrapper
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { LensUpstreamVirtualConnectionsQuery, LensUpstreamVirtualConnectionsQueryVariables, LensUpstreamVirtualConnectionsQuery_lenses_upstreamVirtualConnectionsConnection_nodes } from '../../../gen-src/queries/LensUpstreamVirtualConnectionsQuery';
import { VirtualConnectionsDisplayGridRowDataFragment } from '../../../gen-src/queries/VirtualConnectionsDisplayGridRowDataFragment';
import { VirtualConnectionSortOrder } from '../../../gen-src/queries/globalTypes';
import { LensUpstreamVirtualConnectionsQueryGql } from '../../queries/LensUpstreamVirtualConnectionsQueryGql';
import { getRowDataWithMaxCountsForVirtualConnection } from '../database/functions/VirtualConnectionRowDataFunctions';
import { VirtualConnectionsDisplayGridRowData } from '../database/types/VirtualConnectionDisplayGridRowData';
import { VirtualConnectionsDisplayGrid } from '../sharedDisplayGrid/VirtualConnectionsDisplayGrid';
import { VirtualConnectionsValidSortFields } from '../sorting/sortProviders/VirtualConnectionsGridSortProvider';

type QueryVariables = LensUpstreamVirtualConnectionsQueryVariables;
type QueryResults = LensUpstreamVirtualConnectionsQuery;
type QueryResultListNode = LensUpstreamVirtualConnectionsQuery_lenses_upstreamVirtualConnectionsConnection_nodes;
type GridRowData = VirtualConnectionsDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.lenses[0] && resultData.lenses[0].upstreamVirtualConnectionsConnection;
}

export type LensUpstreamVirtualConnectionsQueryGridProps =
  GridSortProps<VirtualConnectionsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

export const LensUpstreamVirtualConnectionsQueryGrid: React.FC<LensUpstreamVirtualConnectionsQueryGridProps> = props => {
  const { publishedConnectionsLineageEnabled } = React.useContext(FeatureFlagsContext);
  const emptyGridMessage = Messages.EmptyUpstreamVirtualConnectionsLineageGridMessage();

  return (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={LensUpstreamVirtualConnectionsQueryGql}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as VirtualConnectionSortOrder,
        publishedConnectionsLineageEnabled
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForVirtualConnection}
    >
      {({ rowStore }) =>
        <VirtualConnectionsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  );
};

function getRowDataForVirtualConnection(
  virtualConnection: VirtualConnectionsDisplayGridRowDataFragment,
  resultData: QueryResults,
): VirtualConnectionsDisplayGridRowData {
  return getRowDataWithMaxCountsForVirtualConnection(virtualConnection, selectMaxCountsResult(resultData));
}

function selectMaxCountsResult(resultData: QueryResults): MaxCountsResultData {
  return resultData?.lenses && resultData.lenses[0];
}
